import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-split-button-title',
  template: '<ng-content />',
  styleUrls: ['./split-button-title.component.scss']
})
export class SplitButtonTitleComponent {
}
